module.exports = __webpack_public_path__ + "files/deep-learning-school.9d9dfcb6.pdf";